import { useMutation } from '@tanstack/react-query';

import { checkExistingRescue } from 'src/backend/donations';

export default function useCheckExistingRescue() {
  return useMutation({
    mutationFn: checkExistingRescue,
  });
}
